import styles from "./styles.module.scss";

export const EmpoweringGrowth = ({ title, content, image, className = "" }) => {
  return (
    <section className={`${styles.wrapper} ${className}`}>
      <div className={styles.container}>
        <div className={styles.inner}>
          <div className={styles.textContent}>
            <h2
              className={styles.title}
              data-sourceflow-prop="title"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div
              className={styles.content}
              data-sourceflow-prop="content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
          {image?.url && (
            <div className={styles.imageWrapper}>
              <img
                src={image.url}
                alt=""
                className={styles.image}
                data-sourceflow-prop="image"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default EmpoweringGrowth;
